import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {AtsRecordsRowApiModel} from "./ats-records.row.api-model";
import {AtsRecordsRowValueDomainModel} from "./value/ats-records.row-value.domain-model";
import {AtsRecordsRowValueApiModel} from "./value/ats-records.row-value.api-model";

export class AtsRecordsRowDomainModel extends BaseDomainModel {
  apiModel: AtsRecordsRowApiModel;

  get competitorNum(): Number {
    return this.apiModel.competitorNum;
  }

  get isHomeCompetitor(): Boolean {
    return this.apiModel.isHomeCompetitor;
  }

  get values(): Array<AtsRecordsRowValueDomainModel> {
    return this.apiModel.values.map((value: AtsRecordsRowValueApiModel) => new AtsRecordsRowValueDomainModel(value));
  }
}
